module.exports = __webpack_public_path__ + "img/27.b5baee93.png";